module.exports = __webpack_public_path__ + "fonts/Inter-VariableFont_slnt,wght.0930073e.ttf";